export default {"src":"/_next/static/media/popular_choice.59e9e6ee.svg","height":35,"width":125,"blurWidth":0,"blurHeight":0};